// Builds a displayable image src from a blog entry's titleImage + titleImageType,
// mirroring how avatars construct their data URIs.

const getBlogImageSrc = (titleImage?: string, titleImageType?: string) => {
  if (!titleImage) return '';
  if (titleImage.startsWith('data:')) return titleImage;
  if (titleImage.startsWith('http')) return titleImage;
  // Hosted images (e.g. /blog/img/foo.png) — return as-is.
  // Note: JPEG base64 starts with `/9j/` so we check for that first.
  if (titleImage.startsWith('/') && !titleImage.startsWith('/9j/')) return titleImage;
  if (!titleImageType) return '';
  return `data:${titleImageType};base64,${titleImage}`;
};

export default getBlogImageSrc;
